import './styles/globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
